document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.featured-product-new').forEach(function (section) {

    const tabs = section.querySelectorAll('.featured-product-new-tab');
    const panels = section.querySelectorAll('.featured-product-new-panel');

    tabs.forEach(function (tab) {

      tab.addEventListener('click', function () {

        const targetId = tab.dataset.featuredProductNewTab;

        tabs.forEach(function (item) {
          item.classList.toggle('active', item === tab);
        });

        panels.forEach(function (panel) {
          panel.classList.toggle(
            'active',
            panel.dataset.featuredProductNewPanel === targetId
          );
        });

      });

    });

  });

});